import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation();

  // Hide mobile nav on individual chat pages — the chat has its own fixed input bar
  const isChatPage = /^\/messages\/[^/]+$/.test(location.pathname);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="flex">
        <Sidebar className="hidden lg:flex" />
        <main className="flex-1 p-4 lg:p-8 lg:pl-72">{children}</main>
      </div>
      {!isChatPage && <MobileNav className="lg:hidden" />}
    </div>
  );
}
